import { createFileRoute } from "@tanstack/react-router";
import { OwnershipPage } from "./-components/OwnershipPage";

export const Route = createFileRoute(
  "/(restricted)/virksomheder/$cvr/ejerstruktur",
)({
  component: RouteComponent,
});

function RouteComponent() {
  return <OwnershipPage />;
}
